export default __webpack_public_path__ + "static/media/campton_light.65fe788a.ttf";